import { ButtonSize, Color, Notification, PrimaryButton } from '@liveoptics/react-ui';
import React, { useCallback, useState } from 'react';
import { TheaterType } from '../../enums';
import { VerifyOwnerModal } from '../modals/verify-owner/VerifyOwnerModal';

export interface VerifyOwnerAlertProps {
  projectId: number;
  defaultTheater: TheaterType;
  onSuccess: () => void;
}

const VerifyOwnerButton = (props: { onClick: () => void }) => {
  return (
    <PrimaryButton buttonSize={ButtonSize.Small} clickFn={props.onClick}>
      Verify Owner
    </PrimaryButton>
  );
};

export const VerifyOwnerAlert = (props: VerifyOwnerAlertProps) => {
  const [showVerifyOwnerModal, setShowVerifyOwnerModal] = useState(false);
  const [success, setSuccess] = useState<boolean>(false);

  const toggleModal = useCallback(
    (value: boolean) => () => {
      setShowVerifyOwnerModal(value);
      if (!value && success) props.onSuccess();
    },
    [props, success]
  );

  const handleSuccess = useCallback(() => setSuccess(true), []);

  return (
    <>
      <Notification
        button={<VerifyOwnerButton onClick={toggleModal(true)} />}
        message={
          'Warning: Please click Verify Owner to accurately assign the assets of this project.'
        }
        bgColor={Color.gold500}
        iconColor={Color.white}
        textColor={Color.white}
      />
      {showVerifyOwnerModal ? (
        <VerifyOwnerModal
          projectId={props.projectId}
          defaultTheater={props.defaultTheater}
          onClose={toggleModal(false)}
          onSuccess={handleSuccess}
        />
      ) : (
        <></>
      )}
    </>
  );
};
